import React from 'react'
import { Input } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { date as dateFormatter } from 'loankeeper-common/helpers/formatters'
import { LKButton } from 'loankeeper-common/components'
//@ts-ignore
import LKPrintButton, { constants as LKPrintButtonConstants } from 'shared/LKPrintButton'
//@ts-ignore
import { ContentSeparator } from 'shared/ComponentContainers'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
//@ts-ignore
import LKGridExportButton from 'shared/LKGrid/ExportButton'
//@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'
import LKModal, { actions as LKModalActions, LKModalTrigger } from '../../shared/LKModal'
import { actions as DetailsContainerActions, constants as DCConstants } from '../../DetailsContainer'

import { stopAccrualsModalName, undoStopAccrualsModalName } from '../constants'
import translate, { translateLKMessage } from '../translator'

import { AccrualsProps, AccuralsState } from '../types.LoanDetails'
import { stopAccruals, undoStopAccruals, undoStopAccrualsPending } from 'src/store/loan'
import { AppDispatch } from 'src/store/index.d'
import { stopAccrualsPending } from 'src/store/loan'

const DLConfig = {
  gridIdentity: {
    formName: 'frm_loan_view',
    objectName: 'dbgrd_loan_accruals',
  },

  syncGridState: true,
  enableColumnsOrder: true,
  enableColumnsResize: true,
  enableColumnsHide: true,
  enableRowSelection: true,
  showCellFocus: true,

  columnConfigs: {
    ChargeDate: {
      valueFormatter: ({ value }) => LKDate.from(value).toString(),
    },

    AccruedInterest: {
      valueFormatter: ({ value }) => value.toFixed(4),
      cellStyle: { textAlign: 'right' },
    },

    AccruedPenaltyPri: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    AccruedPenaltyInt: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    AccruedUCLC: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    AccruedProcFee: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    OVDPri: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    OVDInt: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    OVDDaysPri: {
      cellStyle: { textAlign: 'right' },
    },

    OVDDaysInt: {
      cellStyle: { textAlign: 'right' },
    },
  },

  getContextMenuItems: () => ['excelExport'],
}

@withConstantPermissions()
//@ts-ignore
@connect(
  (state) => ({
    // stopAccrualsPending: getPending(stopAccrualsFetcherName)(state),
    stopAccrualsPending: stopAccrualsPending(state),
    // undoStopAccrualsPending: getPending(undoStopAccrualsFetcherName)(state),
    undoStopAccrualsPending: undoStopAccrualsPending(state),
  }),
  (dispatch: AppDispatch) => ({
    stopAccruals: (ID: string, hash: string) => {
      // dispatch(
      //   fetchSFM({
      //     instanceName: stopAccrualsFetcherName,
      //     callApi: Loan.stopAccruals,
      //     callApiArgs: [ID, hash],
      //     resolve: () => {
      //       dispatch(DetailsContainerActions.fetchPage({ type: 'Loan', ID, hash, page: 'base' }))
      //     },
      //     reject: ({ Error: { Message, Text } }) => {
      //       dispatch(LKModalActions.openError(Message || Text))
      //     },
      //   }),
      // )

      //UPDATED API REQUEST loan_oper_api page: accrualstop
      dispatch(
        stopAccruals({
          LoanID: ID,
          HashSum_LoanID_: hash,
        }),
      ).then((response) => {
        if (!stopAccruals.fulfilled.match(response)) {
          dispatch(LKModalActions.openError(translateLKMessage(response.payload as string)))
          return
        }
        dispatch(DetailsContainerActions.fetchPage({ type: 'Loan', ID, hash, page: 'base' }))
      })
    },

    undoStopAccruals: (ID: string, hash: string) =>
      // dispatch(
      //   fetchSFM({
      //     instanceName: undoStopAccrualsFetcherName,
      //     callApi: Loan.undoStopAccruals,
      //     callApiArgs: [ID, hash],
      //     resolve: () => {
      //       dispatch(DetailsContainerActions.fetchPage({ type: 'Loan', ID, hash, page: 'base' }))
      //     },
      //     reject: ({ Error: { Message, Text } }) => {
      //       dispatch(LKModalActions.openError(Message || Text))
      //     },
      //   }),
      // ),

      //UPDATED API REQUEST loan_oper_api page: accrualstopundo
      dispatch(
        undoStopAccruals({
          LoanID: ID,
          HashSum_LoanID_: hash,
        }),
      ).then((response) => {
        if (!undoStopAccruals.fulfilled.match(response)) {
          dispatch(LKModalActions.openError(response.payload))
          return
        }
        dispatch(DetailsContainerActions.fetchPage({ type: 'Loan', ID, hash, page: 'base' }))
      }),
  }),
)
class Accruals extends React.Component<AccrualsProps, AccuralsState> {
  state = {
    sum: '0',
  }

  calculateSum = ({ value }: { value: number }, { columnData }: { columnData: number[] }) => {
    if (!isNaN(value)) {
      return this.setState({
        sum: columnData.reduce((result, a) => result + a, 0).toFixed(2),
      })
    }

    this.setState({ sum: 0 })
  }

  render() {
    const {
      ID,
      hash,
      data: {
        accruals,
        base: { AccrueStopDate, IsArrested },
      },
      stopAccruals,
      undoStopAccruals,
      stopAccrualsPending,
      undoStopAccrualsPending,
      permissions,
    } = this.props

    const instanceName = `${DCConstants.DetailsGridPrefixes.loan}-${ID}-Accruals`
    // TODO: investigate if stopAccrualsModalName and undoStopAccrualsModalName are ever opened
    return (
      <>
        {/*@ts-ignore */}
        <LKModal.Confirmation
          name={stopAccrualsModalName}
          onConfirm={() => stopAccruals(ID, hash)}
          loading={stopAccrualsPending}
          warning
        />
        <div className="u-flex u-directionColumn u-fluid">
          <div className="u-fluid u-relative">
            <LKGrid instanceName={instanceName} rowData={accruals} onCellClicked={this.calculateSum} {...DLConfig} />
          </div>

          <div className="u-padding-5 u-flex">
            <LKButton alias="sum" />
            <Input value={this.state.sum} />
          </div>

          <hr style={{ margin: 0 }} />

          <div className="u-flex u-spaceBetween u-padding-5">
            <div className="u-flex">
              {IsArrested !== 1 && permissions.LOAN_STOP && (
                //@ts-ignore
                <LKModalTrigger
                  params={{ message: translateLKMessage('CONFIRM_LOAN_STOP') }}
                  name={stopAccrualsModalName}
                  alias="stop"
                  disabled={!!AccrueStopDate}
                >
                  {translate('cmd_stop')}
                </LKModalTrigger>
              )}
              {!!AccrueStopDate && (
                <div className="u-flex u-marginLeft-10">
                  <ContentSeparator className="u-fluid u-paddingLeft-10 u-paddingRight-10 u-marginRight-5">
                    <div>{translate('pan_stop_date')}</div>
                    <div>{dateFormatter(AccrueStopDate)}</div>
                  </ContentSeparator>
                  {permissions.UNDO_LOAN_STOP && [
                    //@ts-ignore
                    <LKModalTrigger
                      name={undoStopAccrualsModalName}
                      params={{ message: translateLKMessage('CONFIRM_UNDO_STOP') }}
                      alias="undo"
                    >
                      {translate('cmd_undo_stop')}
                    </LKModalTrigger>,

                    //@ts-ignore
                    <LKModal.Confirmation
                      name={undoStopAccrualsModalName}
                      onConfirm={() => undoStopAccruals(ID, hash)}
                      loading={undoStopAccrualsPending}
                      warning
                    />,
                  ]}
                </div>
              )}
            </div>

            <div>
              {IsArrested !== 1 && permissions.PRINT_LOAN_ACCRUALS && (
                <LKPrintButton
                  type={LKPrintButtonConstants.types.loan}
                  upward={true}
                  leftward={true}
                  ID={ID}
                  hash={hash}
                  page="printloanaccruals"
                  name={translate('cmd_print_accruals')}
                />
              )}

              <LKGridExportButton alias="export" instanceName={instanceName} />
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default Accruals
